import { render, staticRenderFns } from "./moderator.vue?vue&type=template&id=9ec10196&scoped=true&"
import script from "./moderator.vue?vue&type=script&lang=js&"
export * from "./moderator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec10196",
  null
  
)

export default component.exports